// Pre-contribution scope (2026-06) — the platform is scoped to the
// pre-contribution period of every loan, so the Payment System v3 wizards
// (right-size / resale / financial-closing) are contributed-loan/investor
// events that must be unreachable while the PreContributionScope flag is
// ON (its default). Each wizard's route default-export wraps itself in
// this gate: a deep link redirects to the loan's detail page instead of
// rendering a stage-2 surface (no dead ends, no 404). Flipping the flag
// off for phase 2 restores the wizards without touching the routes.

import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useFeatureFlag } from "@/hooks/portfolioAdmin/useFeatureFlag";

export function PreContributionScopeRedirect({ children }: { children: ReactNode }) {
  const preContributionScope = useFeatureFlag("PreContributionScope");
  const { loanId } = useParams<{ loanId: string }>();
  if (!preContributionScope) return <>{children}</>;
  return (
    <Navigate
      to={loanId ? `/portfolio-admin/loans/${loanId}` : "/portfolio-admin/loans"}
      replace
    />
  );
}
